import { usePartnerInterest } from "areas/partners/fabric";

import Features from "areas/home/ui/Features";
import Layout from "areas/home/ui/Layout";
import Partners from "areas/home/ui/Partners";
import Subscribe from "areas/home/ui/Subscribe";


export default function Interest() {
	const partner = usePartnerInterest();

	return (
		<Layout>
			<Subscribe {...partner.subscribe} />
			<Partners partners={partner.data} />
			<Features title="Partner Benefits" features={partner.features} />
		</Layout>
	);
}